export const styles = (...stylesheets) => stylesheets
    .flat(Infinity)
    .filter((value) => value !== false && value !== undefined && value !== null && typeof value === 'object');
